import { render, staticRenderFns } from "./post_list.vue?vue&type=template&id=0f9428a0&scoped=true"
import script from "./post_list.vue?vue&type=script&lang=js"
export * from "./post_list.vue?vue&type=script&lang=js"
import style0 from "./post_list.vue?vue&type=style&index=0&id=0f9428a0&prod&lang=css"
import style1 from "./post_list.vue?vue&type=style&index=1&id=0f9428a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9428a0",
  null
  
)

export default component.exports